import { Pipe, PipeTransform } from '@angular/core';
import { Filters } from '../helpers/filters';

@Pipe({
    name: 'textSearch',
    standalone: false
})
export class TextSearchPipe implements PipeTransform {
  public transform(items: any[], field : string, value : string): any[] {  
    return Filters.filterArrayByText(items, field, value);
  }
}